import { diagnosticLog } from './diagnosticLogger';
import { getBlobCoverCacheStats } from './blobCoverCache';
import { getSessionUptimeSeconds } from './gridEntryPerf';
import { getTileCoverArtStats } from './tileCoverArt';

const INTERVAL_MS = 5 * 60 * 1000;

let timer: ReturnType<typeof setInterval> | null = null;

function readHeap(): { usedJSHeapSize: number | null; totalJSHeapSize: number | null } {
  const mem = (performance as Performance & {
    memory?: { usedJSHeapSize?: number; totalJSHeapSize?: number };
  }).memory;
  if (!mem) return { usedJSHeapSize: null, totalJSHeapSize: null };
  return {
    usedJSHeapSize: typeof mem.usedJSHeapSize === 'number' ? mem.usedJSHeapSize : null,
    totalJSHeapSize: typeof mem.totalJSHeapSize === 'number' ? mem.totalJSHeapSize : null,
  };
}

function emitSample(): void {
  const heap = readHeap();
  const cover = getBlobCoverCacheStats();
  const thumb = getTileCoverArtStats();
  diagnosticLog('info', 'js:perf', 'js:perf', {
    session_uptime_s: getSessionUptimeSeconds(),
    usedJSHeapSize: heap.usedJSHeapSize,
    totalJSHeapSize: heap.totalJSHeapSize,
    coverCacheEntries: cover.entryCount,
    coverCacheEstimatedBytes: cover.estimatedBytes,
    blobUrlCount: cover.outstandingBlobUrls,
    thumb_hit: thumb.thumb_hit,
    thumb_miss_fallback: thumb.thumb_miss_fallback,
    thumb_stub_rejected: thumb.thumb_stub_rejected,
    thumb_endpoint_available: thumb.thumb_endpoint_available,
    cache_hit: thumb.cache_hit,
    tile_cache_blob_urls: thumb.tile_cache_blob_urls,
    tile_error_cycles: thumb.tile_error_cycles,
  });
}

export function installJsPerfSampler(): void {
  if (timer || typeof window === 'undefined') return;
  emitSample();
  timer = setInterval(emitSample, INTERVAL_MS);
}

export function stopJsPerfSampler(): void {
  if (!timer) return;
  clearInterval(timer);
  timer = null;
}
